<template>
  <!--回调地址设置-->
  <div class="set-url">
    <el-form :model="param" size="small" label-width="30%" class="form-box">
      <!--<el-form-item label="签署回调地址">-->
      <!--</el-form-item>-->
      <el-form-item label="通用回调地址">
        <div class="display_class">
          <el-input
            v-model="param.notifyUrl"
            placeholder="请输入通用回调地址"
          />
          <el-button
            @click="updateApiInfo"
            type="primary"
            plain
            size="small"
            class="submit"
            >提交</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import MerchantController from "../../assets/js/http-serve/merchantController";

export default {
  data() {
    return {
      param: {
        callbackUrl: "",
        notifyUrl: "",
        notifyUrlAll: 0
      },
      loading: false
    };
  },
  beforeMount() {
    this.getApiParamInfo();
  },
  methods: {
    // 设置api用户回调地址信息
    updateApiInfo() {
      this.$confirm("确认提交？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          MerchantController.ApiUpdateNotifyUrl(this.param)
            .then(() => {
              this.$alert("回调地址设置成功", "系统提示", {
                confirmButtonText: "确定",
                type: "success"
              });
            })
            .catch(() => {
              this.$alert("回调地址设置失败", "系统提示", {
                confirmButtonText: "确定",
                type: "warning"
              });
            });
        })
        .catch(() => {});
    },
    // 获取api用户回调地址的信息
    getApiParamInfo() {
      this.loading = true;
      MerchantController.APINotifyUrl()
        .then(data => {
          this.param = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  name: "set-url"
};
</script>

<style lang="less" scoped>
.set-url {
  max-width: 1200px;
  margin: 10px auto 40px auto;
  .form-box {
    padding: 40px 80px 60px 0;
    max-width: 1000px;
    .display_class {
      display: flex;
      justify-content: space-between;
      .submit {
        margin-left: 20px;
        /*width: 100%;*/
      }
      .el-form-item {
        height: 40px;
        /deep/.el-form-item__content {
          height: 40px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/ent-access/setUrl.vue